import { Injectable, Inject, Injector } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { BaseApi } from "../base-api";
import { APP_CONFIGURATION } from "../../../../../core/src/lib/core.di";
import { AppConfig } from "../../../../../core/src/lib/app-config/config.types";
import { initialPaginatedContent, PaginatedContent } from "../common.types";
import { TalentJobOpportunityDTO, TalentJobOpportunityFilterDTO } from "./talent-job-opportunity.types";

@Injectable({ providedIn: "root" })
export class TalentJobOpportunityApi extends BaseApi {
  private basePath: string;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly injector: Injector,
    @Inject(APP_CONFIGURATION) readonly appConfig: AppConfig,
  ) {
    super(injector);
    this.basePath = appConfig.apiEndpointUrl;
  }

  searchTalentJobOpportunities(
    filter: TalentJobOpportunityFilterDTO,
  ): Observable<PaginatedContent<TalentJobOpportunityDTO>> {
    return this.httpClient.post<any>(`${this.basePath}/job-opportunity-overview/search`, filter).pipe(
      map((response) => {
        if (response.success) {
          // Extract data from response.results['job-opportunities'] structure
          const jobOpportunitiesData = response.results?.["job-opportunities"];
          if (jobOpportunitiesData) {
            return jobOpportunitiesData;
          }
          return response.results.data || initialPaginatedContent;
        } else {
          super.handleErrorResponse(response);
          return initialPaginatedContent;
        }
      }),
      catchError(super.handleHttpError),
    );
  }

  applyToJobOpportunity(jobOpportunityId: string): Observable<boolean> {
    //mock
    console.log("applyToJobOpportunity", jobOpportunityId);
    return of(true);

    // return this.httpClient.post<ApiResponseDTO>(`${this.basePath}/job-opportunity/${jobOpportunityId}/apply`, {}).pipe(
    //   map((response) => {
    //     if (response.success) {
    //       return true;
    //     } else {
    //       super.handleErrorResponse(response);
    //       return false;
    //     }
    //   }),
    //   catchError(super.handleHttpError),
    // );
  }
}
